import * as read_api from "./alan_api";
export function serialize($_report_protocol_reply: read_api.Creport_protocol_reply) {
	const raw_data: Record<string, any> = {};
	{
		let raw_type: Record<string, any>;
		switch ($_report_protocol_reply.properties.type.state.name) {
			case 'delete': {
				const $_delete = $_report_protocol_reply.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_status: Record<string, any>;
					switch ($_delete.properties.status.state.name) {
						case 'failure': {
							const $_failure__status__delete = $_delete.properties.status.state.node;
							const raw_data: Record<string, any> = {};
							raw_status = raw_data
							break;
						}
						case 'success': {
							const $_success__status__delete = $_delete.properties.status.state.node;
							const raw_data: Record<string, any> = {};
							raw_status = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_delete.properties.status.state)
					}
					raw_data["status"] = [$_delete.properties.status.state.name, raw_status];
				}
				raw_type = raw_data
				break;
			}
			case 'listing': {
				const $_listing = $_report_protocol_reply.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				const raw_reports: Record<string, any> = {};
				for (let [k,v] of $_listing.properties.reports) {
					const $_reports = v;
					const raw_data: Record<string, any> = {};
					{
						let raw_permissions: Record<string, any>;
						switch ($_reports.properties.permissions.state.name) {
							case 'read only': {
								const $_read_only = $_reports.properties.permissions.state.node;
								const raw_data: Record<string, any> = {};
								raw_permissions = raw_data
								break;
							}
							case 'writable': {
								const $_writable = $_reports.properties.permissions.state.node;
								const raw_data: Record<string, any> = {};
								raw_permissions = raw_data
								break;
							}
							default:
								throw new Error("unexpected state: " + $_reports.properties.permissions.state)
						}
						raw_data["permissions"] = [$_reports.properties.permissions.state.name, raw_permissions];
					}
					raw_data["type"] = $_reports.properties.type;
					raw_reports[k] = raw_data
				}
				raw_data["reports"] = raw_reports;
				raw_type = raw_data
				break;
			}
			case 'upload': {
				const $_upload = $_report_protocol_reply.properties.type.state.node;
				const raw_data: Record<string, any> = {};
				{
					let raw_status: Record<string, any>;
					switch ($_upload.properties.status.state.name) {
						case 'failure': {
							const $_failure__status__upload = $_upload.properties.status.state.node;
							const raw_data: Record<string, any> = {};
							{
								let raw_cause: Record<string, any>;
								switch ($_failure__status__upload.properties.cause.state.name) {
									case 'duplicate name': {
										const $_duplicate_name = $_failure__status__upload.properties.cause.state.node;
										const raw_data: Record<string, any> = {};
										raw_cause = raw_data
										break;
									}
									case 'invalid name': {
										const $_invalid_name = $_failure__status__upload.properties.cause.state.node;
										const raw_data: Record<string, any> = {};
										raw_cause = raw_data
										break;
									}
									case 'server error': {
										const $_server_error = $_failure__status__upload.properties.cause.state.node;
										const raw_data: Record<string, any> = {};
										raw_cause = raw_data
										break;
									}
									case 'unknown type': {
										const $_unknown_type = $_failure__status__upload.properties.cause.state.node;
										const raw_data: Record<string, any> = {};
										raw_cause = raw_data
										break;
									}
									default:
										throw new Error("unexpected state: " + $_failure__status__upload.properties.cause.state)
								}
								raw_data["cause"] = [$_failure__status__upload.properties.cause.state.name, raw_cause];
							}
							raw_status = raw_data
							break;
						}
						case 'success': {
							const $_success__status__upload = $_upload.properties.status.state.node;
							const raw_data: Record<string, any> = {};
							raw_status = raw_data
							break;
						}
						default:
							throw new Error("unexpected state: " + $_upload.properties.status.state)
					}
					raw_data["status"] = [$_upload.properties.status.state.name, raw_status];
				}
				raw_type = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_report_protocol_reply.properties.type.state)
		}
		raw_data["type"] = [$_report_protocol_reply.properties.type.state.name, raw_type];
	}
	return raw_data;
}